"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'Icon Button require that you use the ' +
    '<code class="inline">iconName</code> property. ' +
    'By default it has a transparent background.';
var code = "import React from 'react';\nimport { IconButton } from 'jsc-react-ui';\n\nconst Example = () => <IconButton iconName=\"plus\" />;";
exports.SimpleExampleIconButton = function () { return (React.createElement(common_1.Example, { title: "Simple", description: description, code: code },
    React.createElement(components_1.IconButton, { iconName: "plus" }))); };
exports.SimpleExampleIconButton.displayName = 'SimpleExampleIconButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconButtonPage/SimpleExampleIconButton.tsx
// module id = 679
// module chunks = 0